module.exports = __webpack_public_path__ + "static/media/hair (32).c90c9c15.jpg";